import moment from "moment";
import fleetlogicAPI from "helpers/fleetlogicAPI";
import { cloneDeep, camelCase } from "lodash";
import * as types from "constants/ActionTypes";
import { WORKORDER_DATE_TIME_FORMAT } from "helpers/timeHelpers";

export const onEmail =
  (documentType, documentNumber, openModal) => (dispatch, getState) => {
    dispatch({
      type: types.ON_MODAL_CHANGE,
      value: { isLoading: true }
    });
    fleetlogicAPI
      .get(
        `/rest-api/email/${documentType}/${encodeURIComponent(documentNumber)}/`
      )
      .then(res => {
        const emailList = res.data.map(e => ({
          label: e.name,
          value: e.email
        }));
        return dispatch({
          type: types.ON_EMAIL,
          value: {
            modal: {
              isModalOpen: openModal,
              isEmail: true,
              emailList
            },
            isLoading: false
          }
        });
      });
  };

export const onPrint = () => (dispatch, getState) => {
  const printers = cloneDeep(getState().printers);
  const printer = printers?.[0];
  return dispatch({
    type: types.ON_PRINT,
    value: {
      modal: {
        isModalOpen: true,
        isPrint: true,
        printerTitle: printer?.name,
        divisionSrmUid: printer?.division,
        printTagType: "red"
      }
    }
  });
};
export const onInvoice = () => (dispatch, getState) => {
  return dispatch({
    type: types.ON_INVOICE,
    value: {
      modal: {
        isModalOpen: true,
        isInvoice: true
      }
    }
  });
};

export const onCloseWO = () => (dispatch, getState) => {
  return dispatch({
    type: types.ON_CLOSE,
    value: {
      modal: {
        isModalOpen: true,
        isClose: true
      }
    }
  });
};

export const onTimeChange = (time, type) => (dispatch, getState) => {
  let workOrderSelected = cloneDeep(getState().workOrderSelected);
  if (time !== null) {
    workOrderSelected[type] = moment(time, "x").format(
      WORKORDER_DATE_TIME_FORMAT
    );
  } else {
    workOrderSelected[type] = null;
  }
  return dispatch({
    type: types.ON_TIME_CHANGE,
    value: {
      workOrderSelected
    }
  });
};

export const onModalChange = e => (dispatch, getState) => {
  const name = camelCase(e.target.name);
  return dispatch({
    type: types.ON_MODAL_CHANGE,
    value: {
      modal: { ...getState().modal, [name]: e.target.value }
    }
  });
};
